import { type ReactNode } from 'react';

import { GalleryActions } from '../components/GalleryAcitons';

import { FavoritesActionButtonContainer } from './FavoritesActionButton';
import { MoreActionsMenuButtonContainer } from './MoreActionsMenuButtonContainer';

export function GalleryActionButtons(): ReactNode {
  return (
    <GalleryActions.Buttons>
      <FavoritesActionButtonContainer />
      <MoreActionsMenuButtonContainer />
    </GalleryActions.Buttons>
  );
}
